import {  selectRatesInfoByProvider } from '@/entities/exchangeRates'
import { formatUSDT } from '@/shared/lib/currency/formatUSDT'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'
import { formatterRub, formatterRubWithCurrency } from '@/shared/utils'
import { useSelector } from 'react-redux'
import { useMerchantData } from '@/entities/merchant/hooks'
import { CurrenciesProvider } from '@/entities/curency'

type Props = {
  currentBalance: number
  totalBalance: number
  className?: string
  type: StatisticTabNames
}

export const ProgressInfo = ({ currentBalance, totalBalance, className, type }: Props) => {
  const percentage = (currentBalance / totalBalance) * 100
  const { dataMerchant } = useMerchantData()

  const selector = selectRatesInfoByProvider({
    currencyRateAddPercent: dataMerchant?.currencyRateAddPercent || null,
    currencyRateProvides: dataMerchant?.currencyRateProvides || CurrenciesProvider.ByBit,
  })

  const { payInRate, payOutRate, lastUpdatedShort } = useSelector(selector)
  const rate = parseFloat((type === 'payIn' ? payInRate : payOutRate).replace('RUB', '').trim())

  const amountUsdt = formatUSDT(currentBalance / rate)

  const validPercentage =
    Number.isFinite(percentage) && percentage > 0 ? Math.min(percentage, 100) : 0

  return (
    <div className={`flex flex-col w-fit ${className}`}>
      <div className="font-klein font-medium text-text-main md:text-[28px] dark:text-white text-2xl">
        <span>{formatterRub.format(currentBalance)}</span>
        <span className="text-text-muted"> / </span>
        <span className="text-text-muted">{formatterRubWithCurrency.format(totalBalance)}</span>
      </div>
      <div className="mb-2 text-text-main dark:text-white text-sm md:text-base">
        <span className="mr-2">~ {amountUsdt ? amountUsdt : '-'}</span>
        <span className="text-text-secondary">
          по курсу {type === 'payIn' ? payInRate : payOutRate} на {lastUpdatedShort}
        </span>
      </div>
      <div className={`w-full h-[6px] bg-card-border rounded-full`}>
        <div
          className={`h-full bg-primary rounded-full`}
          style={{
            width: `${validPercentage}%`,
          }}
        ></div>
      </div>
    </div>
  )
}
